(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;
  const { rainbowToEnergy } = window.RB.CardLib.sfd;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Bard, Mercurial": {
      addCosts: [
        {
          optional: true, cond: null, label: "Bard, Mercurial", costExhaustLegend: true,
          then: [
            {
              op: "choose", bind: "bm", min: 0, max: 99,
              spec: { type: "unit", friendly: true },
              prompt: "Move any number of your units to an open battlefield",
            },
            { op: "move", to: "$bm", destType: "bf", openBf: true },
          ],
        },
      ],
    },

    "Aspiring Engineer": {
      play: [
        {
          op: "choose",
          bind: "t1",
          spec: { type: "gear", zone: "trash" },
          prompt: "Return which gear from your trash?",
        },
        { op: "toHand", to: "$t1" },
      ],
    },

    "Bubble Bot": {
      play: [{ op: "ready", to: "$t1" }],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit", friendly: true, other: true, tag: "Mech" },
          prompt: "Ready...",
        },
      ],
    },

    "Cloth Armor": {
      play: [{ op: "attachSource", to: "$_qd" }],
      targets: [
        {
          bind: "_qd",
          spec: { type: "unit", friendly: true },
          prompt: "Attach Cloth Armor to which unit?",
        },
      ],
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["mind"] }),
      ],
      attachedKw: [["shield", 2]],
    },

    "Experimental Hexplate": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["mind"] }),
      ],
      attachedTags: ["Mech"],
    },

    "Frigid Touch": {
      play: [buff("$t1", -2)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give -2 Might to..." }],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Plundering Poro": {
      triggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, play a Gold gear token exhausted",
          targets: [],
          program: [{ op: "token", name: "Gold", n: 1, loc: "base", exhausted: true }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Premonition": { play: [{ op: "draw", n: 3 }] },

    "The Zero Drive": {
      abilities: [
        equip({ energy: 1, pips: 1, anyPower: 0, domains: ["mind"] }),
        {
          cost: { energy: 3, pips: 1, anyPower: 0, domains: ["mind"] },
          label: "Banish this",
          banishSelf: true,
          targets: [],
          program: [{ op: "playBanishedWith" }],
        },
      ],
      attachedDeathknell: [{ op: "banishDead" }],
    },

    "Wages of Pain": {
      play: [
        { op: "deal", to: "$t1", n: 3 },
        { op: "token", name: "Gold", n: 1, loc: "base", exhausted: true },
      ],
      targets: [
        { bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Deal 3 to..." },
      ],
    },

    "World Atlas": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["mind"] }),
      ],
      attachedTriggers: [
        {
          on: "hold",
          optional: false,
          label: "When I hold, play two Gold gear tokens exhausted",
          targets: [],
          program: [{ op: "token", name: "Gold", n: 2, loc: "base", exhausted: true }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Temporal Portal": {
      abilities: [{
        label: "Give your next spell this turn [Repeat] equal to its cost",
        cost: { energy: 0, pips: 0, anyPower: 1 },
        exhausts: true,
        program: [{ op: "nextPlayMod", mod: "grantRepeat", cardType: "spell", repeatOf: "current" }],
      }],
    },

    "Arcane Shift": {
      targets: [
        { bind: "u", spec: { type: "unit", friendly: true }, prompt: "Banish which friendly unit?" },
        {
          bind: "e", spec: { type: "unit", enemy: true, atBf: true }, min: 0,
          prompt: "Deal 3 to which enemy unit at a battlefield?",
        },
      ],
      play: [
        { op: "banish", to: "$u" },
        { op: "playFrom", to: "$u", waive: "all" },
        { op: "deal", to: "$e", n: 3 },
        { op: "banishSelf" },
      ],
    },

    "Chem-Baroness": {
      triggers: [{
        on: "hold", you: true, optional: true, exhaustSelf: true,
        label: "exhaust me: play a Gold token exhausted",
        condSpec: { k: "selfReady" },
        program: [
          { op: "exhaust", to: "source" },
          { op: "token", name: "Gold", exhausted: true },
        ],
      }],
      addResourceBonus: [{
        tag: "gold",
        cond: { k: "scoreWithin", within: 3 },
        res: { energy: 1, pips: 0, anyPower: 0, domains: null },
      }],
    },

    "Hostile Takeover": {
      targets: [{
        bind: "t", spec: { type: "unit", enemy: true, atBf: true },
        prompt: "Take control of which enemy unit at a battlefield?",
      }],
      play: [
        {
          op: "delayed", on: "endOfTurn", dur: "turn", carry: ["t"],
          label: "Hostile Takeover: give the unit back and recall it",
          program: [{ op: "takeControl", to: "$t", toPlayer: "opponent", recall: true }],
        },
        { op: "takeControl", to: "$t" },
        { op: "ready", to: "$t" },
      ],
    },

    "Chemtech Cask": {
      triggers: [{
        on: "finalizedCard",
        optional: true,
        exhaustSelf: true,
        label: "exhaust me to play a Gold gear token exhausted",
        condSpec: {
          k: "and",
          conds: [
            { k: "evYou" },
            { k: "evType", type: "spell" },
            { k: "notMyTurn" },
            { k: "selfReady" },
          ],
        },
        program: [
          { op: "exhaust", to: "source" },
          { op: "token", name: "Gold", exhausted: true },
        ],
      }],
    },

    "Forecaster": {
      auraKwSpecs: [{
        name: "vision", value: null, who: "friendlyUnits",
        targetCond: { k: "selfTag", tag: "Mech" },
      }],
    },

    "Frostcoat Cub": {
      addCosts: [{
        optional: true,
        cond: null,
        label: "Frostcoat Cub",
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["mind"] },
        thenTargets: [{ bind: "t", spec: { type: "unit" }, prompt: "Give which unit -2 Might this turn?" }],
        then: [buff("$t", -2)],
      }],
    },

    "Gearhead": {
      selfMight: function (state, iid) {
        const o = state.objs[iid];
        let n = 0;
        for (const aIid of o.attachments || []) {
          const ac = Core.card(state, aIid);
          if (ac && typeof ac.might_bonus === "number") n += ac.might_bonus;
        }
        return n;
      },
    },

    "Breakneck Mech": {
      entersReadyCond: { k: "controlsTagOther", tag: "Mech" },
      auraKwSpecs: [
        { name: "deflect", value: 1, who: "friendlyUnits", targetCond: { k: "selfTag", tag: "Mech" } },
        { name: "ganking", value: null, who: "friendlyUnits", targetCond: { k: "selfTag", tag: "Mech" } },
      ],
    },

    "Dropboarder": {
      play: [{
        op: "if",
        cond: { k: "count", spec: { type: "gear", friendly: true, attached: true, ignoreUntargetable: true }, n: 2 },
        then: [{ op: "ready", to: "source" }],
      }],
    },

    "Pickpocket": {
      play: [{
        op: "may",
        prompt: "Kill a gear with Energy cost 1 or less?",
        then: [
          {
            op: "choose", bind: "g", min: 0,
            spec: { type: "gear", maxEnergy: 1, attached: true },
            prompt: "Kill which gear (Energy cost 1 or less)?",
          },
          {
            op: "if", cond: { k: "targetsChosen", bind: "g" },
            then: [
              { op: "kill", to: "$g" },
              { op: "token", name: "Gold", exhausted: true },
            ],
          },
        ],
      }],
    },

    "Production Surge": {
      costMods: [{ energyLess: 2, cond: { k: "controlsTag", tag: "Mech" } }],
      play: [
        { op: "token", name: "Mech" },
        { op: "draw", n: 1 },
      ],
    },

    "Rocket Barrage": {
      targets: [{
        bind: "t",
        spec: {
          orSpecs: [
            { type: "unit", inBase: true },
            { type: "gear", attached: true },
          ],
        },
        prompt: "Choose one: deal 4 to a unit in a base, or kill a gear",
      }],
      play: [{
        op: "if", cond: { k: "targetType", bind: "t", type: "gear" },
        then: [{ op: "kill", to: "$t" }],
        else: [{ op: "deal", to: "$t", n: 4 }],
      }],
      repeatCosts: [{ cost: { energy: 4, pips: 1, anyPower: 0, domains: ["mind"] } }],
    },

    "Bellows Breath": {
      targets: [{
        bind: "a", min: 1, max: 3, cohereLoc: true,
        spec: { type: "unit" },
        prompt: "Deal 1 to up to three units at the same location",
      }],
      play: [{ op: "deal", to: "$a", n: 1 }],
      repeatCosts: [{ cost: { energy: 1, pips: 1, anyPower: 0, domains: ["mind"] } }],
    },

    "Ezreal, Dashing": {
      noCombatDamage: true,
      triggers: [
        {
          on: "attack", self: true,
          label: "attacking: deal my Might to an enemy unit here",
          targets: [{
            bind: "t", spec: { type: "unit", enemy: true, here: true },
            prompt: "Deal Ezreal's Might to which enemy unit here?",
          }],
          program: [{ op: "deal", to: "$t", n: "sourceMight" }],
        },
        {
          on: "defend", self: true,
          label: "defending: deal my Might to an enemy unit here",
          targets: [{
            bind: "t", spec: { type: "unit", enemy: true, here: true },
            prompt: "Deal Ezreal's Might to which enemy unit here?",
          }],
          program: [{ op: "deal", to: "$t", n: "sourceMight" }],
        },
      ],
      abilities: [{
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["mind"] },
        label: "Move me to your base",
        action: true,
        program: [{ op: "move", to: "source", dest: "base" }],
      }],
    },

    "Hextech Anomaly": {
      abilities: [{
        label: "Pay any amount of rainbow Power: Add that much Energy",
        exhausts: true, reaction: true, isAdd: true,
        program: rainbowToEnergy,
      }],
    },

    "Jayce, Man of Progress": {
      play: [{
        op: "may",
        prompt: "Kill a friendly gear to play a gear from hand ignoring its Energy cost?",
        then: [
          {
            op: "choose", bind: "g", min: 0,
            spec: { type: "gear", friendly: true, attached: true },
            prompt: "Kill which friendly gear?",
          },
          {
            op: "if", cond: { k: "targetsChosen", bind: "g" },
            then: [
              { op: "kill", to: "$g" },
              {
                op: "choose", bind: "h", min: 0,
                spec: { type: "gear", zone: "hand", maxEnergy: 7 },
                prompt: "Play which gear from hand, ignoring its Energy cost?",
              },
              { op: "playFrom", to: "$h", waive: "energy" },
            ],
          },
        ],
      }],
    },

    "Ornn, Forge God": {
      selfMight: function (state, iid) {
        const mine = state.objs[iid].controller;
        let n = 0;
        for (const bIid of Core.boardObjs(state)) {
          if (state.objs[bIid].controller !== mine) continue;
          if (Core.isType(state, bIid, "gear")) n += 1;
        }
        return n;
      },
    },

    "Renata Glasc, Mastermind": {
      abilities: [
        {
          cost: { energy: 1, pips: 1, anyPower: 0, domains: ["mind"] },
          label: "Draw 1", needBf: true,
          program: [{ op: "draw", n: 1 }],
        },
        {
          cost: { energy: 4, pips: 4, anyPower: 0, domains: ["mind"] },
          label: "Score 1 point", exhausts: true, needBf: true,
          program: [{ op: "points", n: 1 }],
        },
      ],
    },

    "Rumble, Scrapper": {
      auraMightSpecs: [{ n: 1, who: "friendlyUnits", targetCond: { k: "selfTag", tag: "Mech" } }],
      triggers: [{
        on: "unitHold", self: true,
        label: "play a 3 Might Mech unit token to your base",
        program: [{ op: "token", name: "Mech" }],
      }],
    },

    "Prize of Progress": {
      triggers: [{
        on: "chained",
        label: "a gear ability was used: +1 Might this turn",
        condSpec: {
          k: "and",
          conds: [{ k: "evControllerYou" }, { k: "evAbilitySourceType", type: "gear" }],
        },
        program: [buff("source", 1)],
      }],
    },

    "Card Sharp": {
      play: [
        {
          op: "may", prompt: "Play a Gold gear token exhausted?",
          then: [{ op: "token", name: "Gold", exhausted: true }],
        },
        {
          op: "option", varKey: "cs", byOpponent: true,
          prompt: "Play a Gold gear token exhausted?",
          options: ["Yes", "No"],
        },
        {
          op: "if", cond: { k: "varEq", key: "cs", value: 0 },
          then: [
            { op: "token", name: "Gold", exhausted: true, who: "opponent" },
            { op: "token", name: "Gold", exhausted: true },
          ],
        },
      ],
    },

    "Prodigal Explorer": {
      abilities: [{
        cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
        label: "Draw 1",
        exhausts: true, reaction: true,
        cond: { k: "turnFact", key: "choseEnemy", n: 2 },
        program: [{ op: "draw", n: 1 }],
      }],
    },
  });
})();
